import NotFoundSVG from '../assets/svg/NotFoundSVG.svg?react'

export default function NotFound() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className='w-[600px]'>
        <NotFoundSVG />
      </div>
    </div>
  )
}
